<app-generic-field [rowSpan]="rowSpan" [label]="label" [hideLabel]="hideLabel">
  <textarea [style]="textAreaStyle" [ngModel]="value" (ngModelChange)="valueChange.emit($event)" [placeholder]="placeholder ?? ''"></textarea>
</app-generic-field>
